import React from 'react';
import { useTranslation } from 'react-i18next';
import { combineClassNames } from '@utils/combineClassNames';

type Props = {
  current: number;
  total: number;
};

export const StepIndicator = ({ current, total }: Props) => {
  const { t } = useTranslation();

  return (
    <div className="FreeTrial__Steps" aria-label={t('authentication:trial_step_of', { current, total })}>
      {Array.from({ length: total }, (_, i) => (
        <span
          key={i}
          className={combineClassNames('FreeTrial__Steps__Dot', {
            'FreeTrial__Steps__Dot--done': i + 1 < current,
            'FreeTrial__Steps__Dot--active': i + 1 === current,
          })}
        />
      ))}
    </div>
  );
};
